/* VD GLP Landing Page — shared script for all sections.
   Loaded once (guarded). Handles on-scroll reveal animations and
   smooth-scroll for in-page anchor CTAs. Progressive enhancement:
   if this never runs, all content stays visible. */
(function () {
  if (window.__vdGlp) return;
  window.__vdGlp = true;

  var docEl = document.documentElement;
  docEl.classList.add('vdg-anim');

  function revealAll() {
    var els = document.querySelectorAll('[data-vdg-reveal]:not(.is-revealed)');

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-revealed');
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    els.forEach(function (el) { io.observe(el); });
  }

  function bindSmoothScroll() {
    var isMobile = function () { return window.matchMedia('(max-width: 989px)').matches; };

    // When the GLP header is present it auto-hides on any scroll away from the
    // top, so no space is reserved and the target lands flush at the top.
    // Otherwise measure the theme's own sticky header (.header-wpr) so the target
    // lands right beneath it; fall back to the link's configured data-top offset.
    function headerOffset(link) {
      if (document.querySelector('.section-vd-glp-header')) {
        return 0;
      }
      var themeHeader = document.querySelector('.header-wpr');
      if (themeHeader) {
        var h = themeHeader.getBoundingClientRect().height;
        if (h) return h;
      }
      var attr = isMobile() ? link.getAttribute('data-top-mobile') : link.getAttribute('data-top');
      return parseInt(attr, 10) || 0;
    }

    // Custom rAF scroll instead of native scrollTo({behavior:'smooth'}). The theme
    // sets html { scroll-behavior: smooth } and runs Lenis — both fight a native
    // smooth scroll and drop our offset, landing the target under the header. This
    // forces instant scrolling for the duration and chases the LIVE destination each
    // frame (re-reading the header height + target position), so it always settles
    // right below the sticky header on both mobile and desktop, even if lazy content
    // above shifts the target while we scroll.
    function scrollToTarget(target, link) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var rootStyle = document.documentElement.style;
      var prevBehavior = rootStyle.scrollBehavior;
      rootStyle.scrollBehavior = 'auto';

      // Suppress the sticky-header reveal while this button-driven scroll runs —
      // otherwise scrolling UP to the target (e.g. a CTA below the buy-box) would
      // read as a user scroll-up and pop the header in mid-flight.
      window.__vdgProgrammaticScroll = true;

      var EASE = 0.20;        // chase fraction per 60fps frame
      var RAMP_MS = 260;      // ease-in window so it accelerates from rest (smoothness)
      var SETTLE_PX = 1.5;    // "arrived" tolerance
      var STABLE_MS = 350;    // must stay arrived this long (catches late loads)
      var MAX_MS = 3000;      // hard cap
      var startTs = null, lastTs = null, stableTs = null, cancelled = false;

      function dest() {
        return target.getBoundingClientRect().top + window.pageYOffset - headerOffset(link);
      }
      function cleanup() {
        rootStyle.scrollBehavior = prevBehavior;
        window.__vdgProgrammaticScroll = false;
        window.removeEventListener('wheel', onUser);
        window.removeEventListener('touchmove', onUser);
        window.removeEventListener('keydown', onUser);
      }
      function onUser() { cancelled = true; cleanup(); }
      window.addEventListener('wheel', onUser, { passive: true });
      window.addEventListener('touchmove', onUser, { passive: true });
      window.addEventListener('keydown', onUser);

      function step(ts) {
        if (cancelled) return;
        if (startTs === null) startTs = ts;
        if (lastTs === null) lastTs = ts;
        var dt = Math.min(ts - lastTs, 50);
        lastTs = ts;

        var current = window.pageYOffset;
        var diff = dest() - current;
        // Frame-rate-independent chase easing, plus a short quadratic ease-in ramp
        // at the start so the scroll accelerates from rest (no abrupt first jump)
        // and eases out at the end → smooth ease-in-out feel.
        var frac = 1 - Math.pow(1 - EASE, dt / 16.67);
        var ramp = Math.min(1, (ts - startTs) / RAMP_MS);
        frac *= ramp * ramp;
        var next = reduce ? dest() : current + diff * frac;
        if (Math.abs(diff) < SETTLE_PX) next = dest();
        window.scrollTo(0, next);

        if (Math.abs(diff) < SETTLE_PX) {
          if (stableTs === null) stableTs = ts;
          if (ts - stableTs >= STABLE_MS) { cleanup(); return; }
        } else {
          stableTs = null;
        }

        if (ts - startTs >= MAX_MS) { cleanup(); return; }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    // Move keyboard/screen-reader focus into the target after a button-driven
    // scroll. Without this, activating an anchor CTA (e.g. "Join the
    // Challenge") scrolls the page but leaves focus on the link itself —
    // keyboard and screen-reader users get no indication anything happened
    // and are left stranded at the old position. Prefer the first visible,
    // tabbable control inside the target (mirrors the buy-box's own skip
    // link) so focus lands somewhere useful; fall back to the target itself.
    function focusTarget(target) {
      if (!target) return;
      var dest = null;
      var candidates = target.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]');
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].tabIndex >= 0 && candidates[i].offsetParent !== null) { dest = candidates[i]; break; }
      }
      if (!dest) {
        dest = target;
        var hadTabIndex = dest.hasAttribute('tabindex');
        if (!hadTabIndex) {
          dest.setAttribute('tabindex', '-1');
          dest.addEventListener('blur', function onBlur() {
            dest.removeAttribute('tabindex');
            dest.removeEventListener('blur', onBlur);
          }, { once: true });
        }
      }
      dest.focus({ preventScroll: true });
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href');
      if (!id || id === '#') return;

      var target = null;
      // On MOBILE an optional class/id target takes priority — lets the button
      // land on a different element than on desktop (e.g. the buy-box tabs
      // `.vdhb__tabs` instead of the top of the whole section). Accepts
      // ".class", "class" or "#id"; matches the vd-cro-hero-v2 hero behaviour.
      if (isMobile()) {
        var mobSel = (link.getAttribute('data-scroll-target-mobile') || '').trim();
        if (mobSel) {
          if (mobSel.charAt(0) !== '.' && mobSel.charAt(0) !== '#') mobSel = '.' + mobSel;
          try { target = document.querySelector(mobSel); } catch (err) { target = null; }
        }
      }
      if (!target) target = document.querySelector(id);
      if (!target) return;

      // On mobile, when scrolling to the buy-box, always land on its purchase
      // tabs (GUMMIES/CAPSULES) rather than the top of the gallery. No-op if the
      // target already IS the tabs.
      if (isMobile() && !(target.classList && target.classList.contains('vdhb__tabs'))) {
        var tabsInside = target.querySelector && target.querySelector('.vdhb__tabs');
        if (tabsInside) target = tabsInside;
      }

      e.preventDefault();
      scrollToTarget(target, link);
      focusTarget(target);
    });
  }

  function initSliders() {
    var sliders = document.querySelectorAll('[data-vdg-slider]');
    sliders.forEach(function (slider) {
      if (slider.__vdgSlider) return;
      slider.__vdgSlider = true;

      var track = slider.querySelector('[data-vdg-track]');
      var slides = slider.querySelectorAll('[data-vdg-slide]');
      var prev = slider.querySelector('[data-vdg-prev]');
      var next = slider.querySelector('[data-vdg-next]');
      var count = slides.length;
      if (!track || count === 0) return;

      if (count < 2) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        return;
      }

      var index = 0;
      function update() {
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
      }
      if (prev) prev.addEventListener('click', function () { index = (index - 1 + count) % count; update(); });
      if (next) next.addEventListener('click', function () { index = (index + 1) % count; update(); });
      update();
    });
  }

  function initBuyBox() {
    document.querySelectorAll('[data-vdg-buybox]').forEach(function (box) {
      if (box.__vdgBuybox) return;
      box.__vdgBuybox = true;

      var plans = box.querySelectorAll('[data-vdg-plan]');
      var atc = box.querySelector('[data-vdg-atc]');

      function select(plan) {
        plans.forEach(function (p) {
          var on = p === plan;
          p.classList.toggle('is-selected', on);
          p.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var link = plan.getAttribute('data-link');
        if (atc && link) atc.setAttribute('href', link);
      }

      plans.forEach(function (plan) {
        plan.addEventListener('click', function () { select(plan); });
        plan.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(plan); }
        });
      });

      var main = box.querySelector('[data-vdg-gallery-main]');
      var thumbs = box.querySelectorAll('[data-vdg-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          if (main && full) main.setAttribute('src', full);
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });
    });
  }

  /* Sticky header that hides when scrolling down and reveals when scrolling up
     (and always shows near the very top of the page). */
  function initStickyHeader() {
    var header = document.querySelector('.section-vd-glp-header');
    if (!header || header.__vdgSticky) return;
    // Only when the "Sticky on scroll" setting is on.
    if (!header.querySelector('.vd-glp-header.is-sticky')) return;
    header.__vdgSticky = true;

    var TOP_ZONE = 10;   // px from the top where the header always shows
    var DELTA = 6;       // ignore tiny scroll jitter
    var lastY = window.pageYOffset || 0;
    var ticking = false;

    function update() {
      var y = window.pageYOffset || 0;
      // During a button-driven scroll, keep the header hidden regardless of
      // direction so it doesn't pop in while jumping to the target.
      if (window.__vdgProgrammaticScroll) {
        if (y > TOP_ZONE) header.classList.add('is-hidden');
        mirrorToBody();
        lastY = y;
        ticking = false;
        return;
      }
      if (y <= TOP_ZONE) {
        header.classList.remove('is-hidden');          // always show near the top
      } else if (y > lastY + DELTA) {
        header.classList.add('is-hidden');             // scrolling down → hide
      } else if (y < lastY - DELTA) {
        header.classList.remove('is-hidden');          // scrolling up → show
      }
      mirrorToBody();
      lastY = y;
      ticking = false;
    }

    // Mirror the header's visibility onto <body> so sticky elements further
    // down the page (e.g. the buy box gallery) can collapse their top offset
    // when the header is off-screen, instead of leaving a dead gap.
    function mirrorToBody() {
      document.body.classList.toggle('vd-header-hidden', header.classList.contains('is-hidden'));
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  function init() {
    revealAll();
    bindSmoothScroll();
    initSliders();
    initBuyBox();
    initStickyHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
